module.exports = __webpack_public_path__ + "static/media/undefined-local-scope.da98f0fd.png";